import { useEffect, useState } from "react";
import Tetris from "react-tetris";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function CoffeeBreak() {
  const [scores, setScores] = useState([]);
  const [generalParams, setGeneralParams] = useState();

  const loadHighscores = async () => {
    const general = await api.getGlobalSettings();
    setGeneralParams(general);
    let highscores = general.hasPlayedTetris;
    if (highscores != "") {
      highscores = JSON.parse(highscores);
      highscores.sort((a, b) => -1 * (a.score - b.score));
      highscores = highscores.slice(0, 5);
      console.warn(highscores);
      setScores(highscores);
    }
  };

  useEffect(() => {
    loadHighscores();
  }, []);

  const submitHighscores = async (points) => {
    let newScores = [...scores];
    newScores.push({"name": localStorage.getItem("name"), "score": points});

    await api.updateGlobalSettings({...generalParams,
          hasPlayedTetris: JSON.stringify(newScores)
        });
    loadHighscores();
  };

  return (
    <>
      <h1 className="display-5 fw-bold">Tijd voor een pauze</h1>
      <Tetris
        keyboardControls={{
          // Default values shown here. These will be used if no
          // `keyboardControls` prop is provided.
          down: "MOVE_DOWN",
          left: "MOVE_LEFT",
          right: "MOVE_RIGHT",
          space: "HARD_DROP",
          z: "FLIP_COUNTERCLOCKWISE",
          x: "FLIP_CLOCKWISE",
          up: "FLIP_CLOCKWISE",
          p: "TOGGLE_PAUSE",
          c: "HOLD",
          shift: "HOLD",
        }}
      >
        {({
          HeldPiece,
          Gameboard,
          PieceQueue,
          points,
          linesCleared,
          state,
          controller,
        }) => {

          useEffect(() => {
            if(state === "LOST"){
              submitHighscores(points);
            };
          }, [state])

          return(
          <>
            <div
              style={{
                display: "flex",
                gap: "5em",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <div style={{ flex: "" }}>
                <HeldPiece />
                <div>
                  <p>Points: {points}</p>
                  <p>Lines Cleared: {linesCleared}</p>
                </div>
                {state === "LOST" && (
                  <div>
                    <div>
                      <p>Game Over</p>
                      <button onClick={controller.restart}>New game</button>
                    </div>
                  </div>
                )}
              </div>

              <Gameboard />
              <PieceQueue />
            </div>
            <div>
              <h2>High scores:</h2>
              {scores.length > 0 || <p>No high scores yet</p>}
              {scores.length > 0 && (
                <ol>
                  {scores.map((score, index) =>
                    <li>{score.name.split(' ').map((item) => item.substring(0,2))} : {score.score}</li>)
                  }
                </ol>
              )}
            </div>
          </>
        )}}
      </Tetris>
    </>
  );
}

export default CoffeeBreak;
